import { object, string } from 'prop-types'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'
import Image from '@ui/elements/Image'

const CallPhotoCard = ({ photo, imageProps = {}, address = null }) => {
  const [t] = useTranslation('sterilization')

  return (
    <Div cssClass='call-photo'>
      <Image src={photo.scanPhoto} otherProps={imageProps} />
      <Div cssClass='photoComment'>
        {null !== address
          ? <>
            <p><span>{t('labels.photo_address')} : </span>{address}</p>
            {photo.position?.lat && <p><span>{t('labels.photo_gps')} : </span>{`${photo.position.lat}, ${photo.position.lng}`}</p>}
          </>
          : <>
            {photo.comment && <p><span>{t('labels.comment')} : </span>{photo.comment}</p>}
            <p><span>{t('labels.treated')} : </span>{photo.isTreated ? t('labels.yes') : t('labels.no')}</p>
            <p><span>{t('labels.mission_subject')} : </span>{photo.missionSubjectName}</p>
            <p><span>{t('labels.scan')} : </span>
              {photo.isFirstScan ? t('labels.first_scan') : (photo.isSecondScan ? t('labels.second_scan') : t('labels.non_indicated'))}</p>
          </>
        }
      </Div>
    </Div>
  )
}

CallPhotoCard.propTypes = {
  photo: object,
  imageProps: object,
  address: string
}

export default CallPhotoCard
